import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { BookOpen, ArrowRight, Calendar } from "lucide-react";

export default function Articles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const resolveUrl = (u) => (u && u.startsWith("/") ? `${apiBase}${u}` : u);

  useEffect(() => {
    api.get("/blog").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="bg-brand-creamSoft border-b border-brand-beige">
        <div className="max-w-7xl mx-auto container-x py-20">
          <p className="text-brand-red font-semibold text-xs uppercase tracking-[0.2em] mb-3">Educație orală</p>
          <h1 className="font-display font-extrabold text-brand-navy text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl text-balance">
            Educație pentru sănătate orală
          </h1>
          <p className="mt-4 text-brand-navy/70 text-lg max-w-2xl font-light">Articole și informații pentru pacienți.</p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto container-x py-16">
        {loading ? (
          <div className="text-brand-navy/60">Se încarcă…</div>
        ) : !items.length ? (
          <div className="bg-white rounded-2xl p-12 border border-brand-beige text-center">
            <BookOpen className="w-12 h-12 text-brand-navy/30 mx-auto" />
            <p className="mt-4 text-brand-navy/70">Niciun articol publicat încă. Reveniți în curând!</p>
          </div>
        ) : (
          <div className="space-y-6">
            {items.map((p) => (
              <Link
                key={p.id}
                to={`/articole/${p.slug}`}
                className="block bg-white rounded-2xl border border-brand-beige hover:border-brand-yellow hover:shadow-soft transition-all overflow-hidden"
                data-testid={`article-${p.slug}`}
              >
                <div className="grid sm:grid-cols-3 gap-0">
                  {p.cover_image && (
                    <div className="aspect-[4/3] sm:aspect-auto bg-brand-cream overflow-hidden">
                      <img src={resolveUrl(p.cover_image)} alt={p.title} className="w-full h-full object-cover" draggable={false} />
                    </div>
                  )}
                  <div className={`p-7 ${p.cover_image ? 'sm:col-span-2' : 'sm:col-span-3'}`}>
                    <div className="flex items-center gap-2 text-xs text-brand-navy/55 font-medium">
                      <Calendar className="w-3.5 h-3.5" />
                      {new Date(p.created_at).toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" })}
                    </div>
                    <h2 className="mt-2 font-display font-bold text-brand-navy text-2xl tracking-tight">{p.title}</h2>
                    <p className="mt-3 text-brand-navy/70 leading-relaxed line-clamp-3">{p.excerpt}</p>
                    <div className="mt-5 inline-flex items-center gap-1.5 text-brand-red font-semibold text-sm">
                      Citește articolul <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
